import { HTMLProps, forwardRef } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
    },
  });

type RootProps = HTMLProps<HTMLDivElement> & WithStyles<typeof styles>;

const Root = forwardRef<HTMLDivElement, RootProps>((props, ref) => {
  const { classes, className, ...other } = props;
  return (
    <div ref={ref} className={classNames(classes.root, className)} {...other} />
  );
});

Root.displayName = 'StateIcon.Root';

export default withStyles(styles)(Root);
